export default "__VITE_ASSET__C$EERuiZ__"